
import RelationToOneField from '@/shared/fields/relation-to-one-field';
import { DocumentSeriesAllocationService } from '@/modules/document-series-allocation/document-series-allocation-service';

export class ActiveDocumentSeriesField {
    static relationToOne(name, label, rules, filterParams, children, options) {
        return new RelationToOneField(
            name,
            label,
            DocumentSeriesAllocationService.getActiveSeries,
            (record) => {
                if (!record) {
                    return '';
                }
                return {
                    value: record.type_id,
                    text: record.type_name,
                };
            },
            rules,
            filterParams,
            children,
            options,
        );
    }
}
